module.exports = __webpack_public_path__ + "static/media/coupe11.7234b2ca.jpg";